import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=51a83a8e&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a83a8e')) {
      api.createRecord('51a83a8e', component.options)
    } else {
      api.reload('51a83a8e', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=51a83a8e&", function () {
      api.rerender('51a83a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TmjCJ8aAlx5B/JS/comp/ErrorMessage.vue"
export default component.exports